// extracted by mini-css-extract-plugin
export var accordionItem = "AccordionChild-module--accordionItem--3iXu-";
export var accordionButton = "AccordionChild-module--accordionButton--16bGi";
export var content = "AccordionChild-module--content--11Bkw";
export var arrowUp = "AccordionChild-module--arrowUp--2vK2x";
export var arrowDown = "AccordionChild-module--arrowDown--ij3R5";